/* eslint-disable max-statements */
import { replace } from "connected-react-router";
import { useDispatch } from "react-redux";
import { useDeleteWorkspaceMutation } from "../store/api";
import { useHandleSetDefaultWorkspace } from "./handleSetDefaultWorkspace";
import { useDashboardFullPathInformations } from "./use-current-dashboard";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { setMessagesDialog } from "store/messages-dialog";
export const useHandleDeleteWorkspace = () => {
    const dispatch = useDispatch();
    const { pathInformations } = useDashboardFullPathInformations();
    const [deleteWorkspace] = useDeleteWorkspaceMutation();
    const { handleSetDefaultWorkspace } = useHandleSetDefaultWorkspace();
    const handleDeleteWorkspace = async (id, workspaceAndPreferences) => {
        if (!id) {
            return;
        }
        await deleteWorkspace({ name: id });
        const indexToRemove = workspaceAndPreferences.findIndex((workspace) => workspace.id === id);
        if (indexToRemove === -1) {
            return;
        }
        const currentDeletedWorkspace = workspaceAndPreferences[indexToRemove];
        const updatedWorkspaceAndPreferences = [
            ...workspaceAndPreferences.slice(0, indexToRemove),
            ...workspaceAndPreferences.slice(indexToRemove + 1)
        ];
        const nextDefaultWorkspace = updatedWorkspaceAndPreferences.find((workspace) => workspace.isDefault === true);
        if (currentDeletedWorkspace.isDefault) {
            if (nextDefaultWorkspace) {
                handleSetDefaultWorkspace(nextDefaultWorkspace);
                dispatch(replace(`${pathInformations.slice(0, 3).join("/")}`));
            }
            else {
                const productDefaultWorkspace = updatedWorkspaceAndPreferences.find((workspace) => workspace.isEditable === false);
                if (productDefaultWorkspace) {
                    const blackRockWorkspace = {
                        ...productDefaultWorkspace,
                        isDefault: true,
                        orderNumber: 0
                    };
                    handleSetDefaultWorkspace(blackRockWorkspace);
                }
            }
        }
        else {
            dispatch(replace(`${pathInformations.slice(0, 3).join("/")}/${nextDefaultWorkspace?.id}`));
        }
        dispatch(setMessagesDialog({
            functionName: MessagesDialogFunctionName.Default,
            messages: [],
            title: "",
            type: undefined
        }));
    };
    return { handleDeleteWorkspace };
};
